import { CountryRegion } from '@Common/countries/regions';
import { Amount } from '@Common/types/Amount';

type DefinedCountryRegion = Exclude<CountryRegion, undefined> | 'DEFAULT';

type RegionBasedAmounts = {
  [key in DefinedCountryRegion]: Amount;
};

export const CARD_TOPUP_MIN_AMOUNT: RegionBasedAmounts = {
  UK: { currency: 'GBP', value: 500 },
  EU: { currency: 'EUR', value: 500 },
  DEFAULT: { currency: 'GBP', value: 500 },
};

export const CARD_TOPUP_BUSINESS_MIN_AMOUNT: RegionBasedAmounts = {
  UK: { currency: 'GBP', value: 50000 },
  EU: { currency: 'EUR', value: 50000 },
  DEFAULT: { currency: 'GBP', value: 50000 },
};

export const CARD_TOPUP_MAX_AMOUNT: RegionBasedAmounts = {
  UK: { currency: 'GBP', value: 500000 },
  EU: { currency: 'EUR', value: 500000 },
  DEFAULT: { currency: 'GBP', value: 500000 },
};

export const CARD_TOPUP_MIN_AMOUNT_CENTS = CARD_TOPUP_MIN_AMOUNT.DEFAULT.value;
export const MAX_TOPUP_AMOUNT: Amount = { currency: 'GBP', value: 1000000 };
